/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import {
  RiGitPullRequestFill, RiMessage2Line, RiServiceLine,
  RiHeartLine, RiAccountCircleLine,
} from 'react-icons/ri';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import MyRequest from './my-request/Requests';
import MyMessage from './MyMessage';
import MyService from './MyService';
import Favorite from './Favorite';
// import ProfileSetting from './ProfileSetting';
import BuyerDetailData from '../registration/BuyerDetailData';

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node, //eslint-disable-line
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="my-12 sm:mx-10 sm:px-2 py-2 bg-white border-2 rounded-lg">
      <div className="border-b-2">
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          allowScrollButtonsMobile
          aria-label="basic tabs example"
          className="mt-2 overflow-x-scroll"
        >
          <Tab icon={<RiGitPullRequestFill />} iconPosition="start" label="My Requests" {...a11yProps(0)} />
          <Tab icon={<RiMessage2Line />} iconPosition="start" label="Messages" {...a11yProps(1)} />
          <Tab icon={<RiServiceLine />} iconPosition="start" label="My Services" {...a11yProps(2)} />
          <Tab icon={<RiHeartLine />} iconPosition="start" label="Favorite" {...a11yProps(3)} />
          <Tab icon={<RiAccountCircleLine />} iconPosition="start" label="Profile Setting" {...a11yProps(4)} />
        </Tabs>
      </div>
      <TabPanel value={value} index={0}>
        <MyRequest title="My Request" />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <MyMessage />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <MyService />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Favorite />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <BuyerDetailData marginStyle="mt-3" paddingStyle="p-2" />
      </TabPanel>
    </div>
  );
}
